import { gql } from '@apollo/client';

const CREDIT_PROTECTION_SNAPSHOT = gql`
  query CreditProtectionSnapshot($accountId: String!) {
    creditProtectionSnapshot(accountId: $accountId)
  }
`;

export { CREDIT_PROTECTION_SNAPSHOT };
